<div class="item-container">
  <div class="pic-container">
    <div
      class="pic-image"
      [ngStyle]="{ backgroundImage: 'url(' + item.img + ')' }"></div>
  </div>
  <div class="text-container">
    @if (!contentEdit) {
      <h3>{{ item.headline }}</h3>
    }
    @if (contentEdit) {
      <h3
        #heading
        [contentEditable]="contentEdit"
        [textContent]="item.headline"
        (input)="item.headline = heading.textContent ? heading.textContent : 'headline'"></h3>
    }
    @if (!contentEdit) {
      <p
        style="margin-top: 30px; margin-bottom: 30px"
        [innerHTML]="item.text"></p>
    }
    @if (contentEdit) {
      <coin-html-editor
        style="margin-top: 15px"
        [item]="item"
        [contentEdit]="true"
        [isNews]="true"></coin-html-editor>
    }
    @if (item.link && item.link.length) {
      <div class="link">
        @if (!contentEdit) {
          <coin-v2-button
            type="primary"
            icon="arrow"
            [text]="item.buttonText"
            (click)="gotoPage(item.link)"></coin-v2-button>
        }
        <!-- <a *ngIf="!contentEdit" [href]="item.link" target="_blank">{{getTranslateText(item.buttonText)}}</a> -->
        @if (contentEdit) {
          <coin-v2-text-input
            [label]="'cms.button-text' | translate"
            [placeholder]="'Button text'"
            [disabled]="!contentEdit"
            [(ngModel)]="item.buttonText" />
        }
        @if (contentEdit) {
          <coin-v2-text-input
            [label]="'cms.button-link-url' | translate"
            [placeholder]="'https://...'"
            [disabled]="!contentEdit"
            [(ngModel)]="item.link" />
        }
      </div>
    }
  </div>
</div>

@if (contentEdit) {
  <div class="inputs">
    @if (contentEdit) {
      <coin-v2-button
        type="secondary"
        icon="edit"
        text="Change Picture"
        (click)="editPicture(item)"></coin-v2-button>
    }
  </div>
}
